export default {
  user(state) {
    return state.user;
  },
  accesstoken(state) {
    return state.accesstoken;
  },
  drawer(state) {
    return state.drawer;
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js